import React, { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { draganddrop } from "./draganddrop"; // your data source

let lastIndex = 0;

const DragAndDrop = () => {
  const [selectedItems, setSelectedItems] = useState<any[]>([]);
  const [availableItems, setAvailableItems] = useState<any[]>([]);
  const [statics, setStatics] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [isDraggingFromBox1, setIsDraggingFromBox1] = useState(false);

  // Replace this with your actual static items if any
  const staticItems: any[] = [];

  useEffect(() => {
    getAccounts("Savings", "ACT");
  }, []);

  const getAccounts = (productType: any, active: any) => {
    setLoading(true);
    try {
      const response = draganddrop;

      let extConnResponse: any[] =
        response[0]?.depositAccountDetails?.depositMessage?.depositList?.deposit || [];

      const savingsArray = extConnResponse
        .filter(
          (account) =>
            account.type === "Savings" &&
            account.depositAccountSubStatus === "ACT"
        )
        .map((account) => ({
          ...account,
          accountId: account.accountId.split(":")[1], // remove prefix
        }));

      const maskedSavingsArray = savingsArray.map((item) => ({
        ...item,
        id: item.accountId.toString(),
        maskedAccountId: `xxxx${item.accountId.toString().slice(-4)}`,
      }));

      const maskedStaticArray = staticItems.map((item, idx) => ({
        ...item,
        id: item.DrawAccountNumber?.toString() || `static-${idx}`,
        maskedAccountId: `xxxx${item.DrawAccountNumber?.toString().slice(-4)}`,
      }));

      if (staticItems.length > 0) {
        const drawAccountNumbers = new Set(
          maskedStaticArray.map((item) => String(item.DrawAccountNumber))
        );
        const filteredAvailable = maskedSavingsArray.filter(
          (item) => !drawAccountNumbers.has(String(item.accountId))
        );
        setAvailableItems(filteredAvailable);
      } else {
        setAvailableItems(maskedSavingsArray);
      }

      setStatics(maskedStaticArray);
      lastIndex = staticItems.length;
      setLoading(false);
    } catch (error) {
      console.error("Error loading accounts:", error);
      setLoading(false);
    }
  };

  const handleDragStart = (start: any) => {
    setIsDraggingFromBox1(start.source.droppableId === "box1");
  };

  const handleDragUpdate = (update: any) => {
    const { source, destination } = update;
    setIsDraggingFromBox1(
      source?.droppableId === "box1" &&
        destination?.droppableId === "box2"
    );
  };

  const handleDragEnd = (result: any) => {
    setIsDraggingFromBox1(false);
    if (!result.destination) return;

    const sourceId = result.source.droppableId;
    const destId = result.destination.droppableId;

    // From Available to Selected
    if (sourceId === "box1" && destId === "box2") {
      const itemToMove = availableItems.find(
        (item) => item.id === result.draggableId
      );
      if (itemToMove) {
        setSelectedItems((prev) => {
          const updated = [...prev];
          updated.splice(result.destination.index, 0, itemToMove);
          return updated.map((item, index) => ({
            ...item,
            order: `${index + 1}`,
          }));
        });
        setAvailableItems((prev) =>
          prev.filter((item) => item.id !== itemToMove.id)
        );
      }
    }
    // Reorder inside Selected
    else if (sourceId === "box2" && destId === "box2") {
      setSelectedItems((prev) => {
        const updated = Array.from(prev);
        const [moved] = updated.splice(result.source.index, 1);
        updated.splice(result.destination.index, 0, moved);
        return updated.map((item, index) => ({
          ...item,
          order: `${index + 1}`,
        }));
      });
    }
    // From Selected back to Available
    else if (sourceId === "box2" && destId === "box1") {
      const itemToMove = selectedItems.find(
        (item) => item.id === result.draggableId
      );
      if (itemToMove) {
        setAvailableItems((prev) => {
          const updated = [...prev];
          updated.splice(result.destination.index, 0, itemToMove);
          return updated;
        });
        setSelectedItems((prev) =>
          prev.filter((item) => item.id !== itemToMove.id)
        );
      }
    }
  };

  return (
    <div className="drag_container">
      <h5>SELECTED_ACCOUNTS</h5>
      {statics.map((item, idx) => (
        <div className="draggable_item" key={item.id || idx}>
          <div className="account_name">
            <span className="order_number bg-secondary text-light">
              {item.DrawSequence}
            </span>
            <div>
              <h6 className="text-secondary">
                {item.MinorAccountTypeDescription} {item.MajorAccountTypeDescription}
              </h6>
              <p>{item.maskedAccountId || item.accountId}</p>
            </div>
          </div>
        </div>
      ))}

      <DragDropContext
        onDragStart={(start) => {
          if (start.source.droppableId === "box1") {
            document.body.classList.add("dragging");
          }
          handleDragStart(start);
        }}
        onDragUpdate={handleDragUpdate}
        onDragEnd={(result) => {
          document.body.classList.remove("dragging");
          handleDragEnd(result);
        }}
      >
        <Droppable droppableId="box2">
          {(provided) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {selectedItems.length === 0 && availableItems.length !== 0 && (
                <div className="no_draggable_item text-secondary">DROPIT</div>
              )}
              {selectedItems.map((item, index) => (
                <Draggable key={item.id} draggableId={item.id} index={index}>
                  {(provided, snapshot) => (
                    <div
                      className={`draggable_item ${
                        snapshot.isDragging ? "dragging" : ""
                      }`}
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={{
                        ...provided.draggableProps.style,
                        transform:
                          provided.draggableProps.style?.transform?.replace(
                            /translate\([^,]+,\s*([^)\s]+)\)/,
                            "translate(0px, $1)"
                          ),
                      }}
                    >
                      <div className="account_name">
                        <span className="order_number">{index + lastIndex + 1}</span>
                        <div>
                          <strong>{item.description}</strong>
                          <p>{item.maskedAccountId}</p>
                        </div>
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>

        <div
          className={`available-header ${
            isDraggingFromBox1 ? "dragging-from-box1" : ""
          }`}
        >
          <h5>AVAILABLE_ACCOUNTS</h5>
        </div>

        <Droppable droppableId="box1">
          {(provided) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {availableItems.length === 0 && (
                <div className="no_draggable_item text-secondary">NO_AVAILABLE</div>
              )}
              {availableItems.map((item, index) => (
                <Draggable key={item.id} draggableId={item.id} index={index}>
                  {(provided, snapshot) => (
                    <div
                      className={`draggable_item ${
                        snapshot.isDragging ? "dragging" : ""
                      }`}
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={{
                        ...provided.draggableProps.style,
                        transform:
                          provided.draggableProps.style?.transform?.replace(
                            /translate\([^,]+,\s*([^)\s]+)\)/,
                            "translate(0px, $1)"
                          ),
                      }}
                    >
                      <div className="account_name">
                        <div>
                          <strong>{item.description}</strong>
                          <p>{item.maskedAccountId}</p>
                        </div>
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      {selectedItems?.length > 0 && (
          <div className="w-100 d-flex gap-2 justify-content-end">
            <button
              className="custom-btn secondary"
            >
              CANCEL
            </button>
            <button className="custom-btn danger" >
              PROCEED
            </button>
          </div>
        )}
    </div>
  );
};

export default DragAndDrop;
